module.exports = __webpack_public_path__ + "img/item_image01.4fca9cf8.jpg";